import $ from '@ali/tarzan-zepto';
import events from 'events';

import Scroll from './scroll/scroll';

class Body extends events {
  constructor(config) {
    super();
    this.bridge = config.bridge;
    this.$container = $(config.container);
    this.__initScroll();
    this.__imagePreview();
  }

  /**
   * 重置窗口
   */
  resize(bottom, top) {
    // FIX no need to judge
    // if (true || bottom && top) {
    // }
    this.$container.css({
      bottom,
      top,
    });
    this.refresh();
  }

  refresh() {
    this.__scroll.refresh();
  }

  __imagePreview() {
    this.$container.delegate('img', 'tap', () => {
      // const $target = $(ev.currentTarget);
      // let src = $target.attr('src');

      // // 如果图片是刚上传的，地址写在cdn src里，那就取cdn src的地址
      // if ($target.hasClass('base64-img')) {
      //   src = $target.attr('cdn-src');
      // }
      // // gif不放大
      // if (src.endsWith('.gif')) {
      //   return;
      // }
      // // 头像，文章卡片里的图片，表情，base64 点击不放大
      // if ($target.hasClass('J_DisableZoomIn')) {
      //   return;
      // }
      // // 是带链接的图片
      // if ($target.parent().attr('href')) {
      //   return;
      // }

      // // 显示大图,工作台上传图片接口固定加上_310x310
      // src = src.replace(/(_310x310)/, '');
      // // this.bridge.imagePreview({
      // //   images: [src],
      // // });
    });
  }

  __initScroll() {
    this.__scroll = new Scroll({
      container: this.$container,
    });

    this.__scroll.on('pull', () => {
      this.emit('pullToRefresh');
    });

    this.__scroll.on('pullEvent', (e) => {
      this.emit('pullDistance', e);
    });
    this.append = content => this.__scroll.append(content);
    this.prepend = content => this.__scroll.prepend(content);
    this.refresh = () => this.__scroll.refresh();
    this.scrollToElement = el => this.__scroll.scrollToElement(el);
    this.scrollToTop = () => this.__scroll.scrollToTop();
    this.scrollToBottom = () => this.__scroll.scrollToBottom();
    this.isBottom = () => this.__scroll.isBottom();
    this.addAnimation = (time = 1000) => this.__scroll.addAnimation(time);
    this.rmAnimation = () => this.__scroll.rmAnimation();

    this.$scroll = this.__scroll.$el;
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/component/view/body/index.js